export default __webpack_public_path__ + "static/media/halfHalf.4cb84239.png";